// RenderContent.js
import React from 'react';
import { Box, Typography, CardMedia } from '@mui/material';

const RenderContent = ({ content }) => {

  // Function to render parts of the content if it has parts (i.e., for 'paragraph' type)
  const renderParts = (parts) => {
    return parts.map((part, index) => (
      <Box key={index} sx={{ my: 3 }}>
        <RenderContent content={part} />
      </Box>
    ));
  };

  switch (content.type) {
    case 'text':
      // Directly return a Typography component for 'text' type
      return <Typography sx={{ ...content.style, mt: 2 }}>{content.text}</Typography>;
    case 'paragraph':
      // Recursively call RenderContent on each part for 'paragraph' type
      return (
        <Box>
          {renderParts(content.parts)}
        </Box>
      );
    case 'image':
      return (
        <Box sx={{ mt: 2 }}>
          <CardMedia component="img" image={content.src} alt={content.alt}
            sx={{
              borderRadius: '2rem',
              mt: 2,
              width: '100%',
              // height: { xs: 'auto', md: '600px' },
              objectFit: 'cover'
            }}
          />
          <Typography variant="caption" sx={{ display: 'block', textAlign: 'center' }}>{content.description}</Typography>
        </Box>
      );
    case 'video':
      return (
        <Box sx={{ mt: 2 }}>
          <iframe src={content.embedUrl} style={{ width: '100%', height: '330px', borderRadius: '1rem' }}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen>
          </iframe>
          <Typography variant="caption" sx={{ display: 'block', textAlign: 'center' }}>{content.description}</Typography>
        </Box>
      );
    case 'list':
      return (
        <Box component="ul" sx={{ mt: 2 }}>
          {content.items.map((item, index) => (
            <Box component="li" key={index} sx={{ mt: 1 }}>
              {typeof item === 'string' ? item : <a href={item.url} target="_blank" rel="noopener noreferrer">{item.text}</a>}
            </Box>
          ))}
        </Box>
      );
    default:
      return null;
  }
};

export default RenderContent;